var _a;
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { AddIcon } from './AddIcon';
import { ArrowLeftIcon } from './ArrowLeftIcon';
import { ArrowRightIcon } from './ArrowRightIcon';
import { BriefcaseIcon } from './BriefcaseIcon';
import { CalendarIcon } from './CalendarIcon';
import { ChatIcon } from './ChatIcon';
import { CheckIcon } from './CheckIcon';
import { CheckCircleIcon } from './CheckCircleIcon';
import { CloseIcon } from './CloseIcon';
import { CloseCircleIcon } from './CloseCircleIcon';
import { CNIIcon } from './CNIIcon';
import { ColumnsIcon } from './ColumnsIcon';
import { CopyIcon } from './CopyIcon';
import { CSVIcon } from './CSVIcon';
import { DownloadIcon } from './DownloadIcon';
import { EditIcon } from './EditIcon';
import { EmptyBoltIcon } from './EmptyBoltIcon';
import { ExchangeIcon } from './ExchangeIcon';
import { ExportIcon } from './ExportIcon';
import { FilterIcon } from './FilterIcon';
import { FolderIcon } from './FolderIcon';
import { FullArrowRightIcon } from './FullArrowRightIcon';
import { FullBoltIcon } from './FullBoltIcon';
import { FullscreenIcon } from './FullscreenIcon';
import { FullscreenExitIcon } from './FullscreenExitIcon';
import { GroupIcon } from './GroupIcon';
import { HeartPulseIcon } from './HeartPulseIcon';
import { HistoryIcon } from './HistoryIcon';
import { InfoIcon } from './InfoIcon';
import { IdentityFraudIcon } from './IdentityFraudIcon';
import { IdentityIncompleteIcon } from './IdentityIncompleteIcon';
import { IdentityNeverCompletedIcon } from './IdentityNeverCompletedIcon';
import { IdentityToStudyIcon } from './IdentityToStudyIcon';
import { IdentityValidIcon } from './IdentityValidIcon';
import { InformationIcon } from './InformationIcon';
import { LockIcon } from './LockIcon';
import { LogoutIcon } from './LogoutIcon';
import { MessageIcon } from './MessageIcon';
import { MoreIcon } from './MoreIcon';
import { NotificationOffIcon } from 'src/ui/components/Icons/collection/NotificationOffIcon';
import { NotificationOnIcon } from 'src/ui/components/Icons/collection/NotificationOnIcon';
import { PDFIcon } from 'src/ui/components/Icons/collection/PDFIcon';
import { PictureIcon } from './PictureIcon';
import { PauseIcon } from './PauseIcon';
import { PlayIcon } from './PlayIcon';
import { QuestionIcon } from './QuestionIcon';
import { QuestionCircleIcon } from './QuestionCircleIcon';
import { QuicksignIcon } from './QuicksignIcon';
import { RefreshIcon } from './RefreshIcon';
import { RollbackIcon } from './RollbackIcon';
import { RotateLeftIcon } from './RotateLeftIcon';
import { RotateRightIcon } from './RotateRightIcon';
import { SearchIcon } from './SearchIcon';
import { SendIcon } from './SendIcon';
import { SettingsIcon } from './SettingsIcon';
import { StatementIcon } from './StatementIcon';
import { SubIcon } from './SubIcon';
import { TrashIcon } from './TrashIcon';
import { UserIcon } from './UserIcon';
import { WalletIcon } from './WalletIcon';
import { WarningIcon } from './WarningIcon';
import { ZoomIn } from 'src/ui/components/Icons/collection/ZoomIn';
import { ZoomOut } from 'src/ui/components/Icons/collection/ZoomOut';
export var ICONS = (_a = {},
    _a[E_ICONS.ADD] = AddIcon,
    _a[E_ICONS.ARROW_LEFT] = ArrowLeftIcon,
    _a[E_ICONS.ARROW_RIGHT] = ArrowRightIcon,
    _a[E_ICONS.BRIEFCASE] = BriefcaseIcon,
    _a[E_ICONS.CALENDAR] = CalendarIcon,
    _a[E_ICONS.CHAT] = ChatIcon,
    _a[E_ICONS.CHECK] = CheckIcon,
    _a[E_ICONS.CHECK_CIRCLE] = CheckCircleIcon,
    _a[E_ICONS.CLOSE] = CloseIcon,
    _a[E_ICONS.CLOSE_CIRCLE] = CloseCircleIcon,
    _a[E_ICONS.CNI_ICON] = CNIIcon,
    _a[E_ICONS.COLUMNS] = ColumnsIcon,
    _a[E_ICONS.COPY] = CopyIcon,
    _a[E_ICONS.CSV] = CSVIcon,
    _a[E_ICONS.DOWNLOAD] = DownloadIcon,
    _a[E_ICONS.EDIT] = EditIcon,
    _a[E_ICONS.EMPTY_BOLT] = EmptyBoltIcon,
    _a[E_ICONS.EXCHANGE] = ExchangeIcon,
    _a[E_ICONS.EXPORT] = ExportIcon,
    _a[E_ICONS.FILTER] = FilterIcon,
    _a[E_ICONS.FOLDER] = FolderIcon,
    _a[E_ICONS.FULL_ARROW_RIGHT] = FullArrowRightIcon,
    _a[E_ICONS.FULL_BOLT] = FullBoltIcon,
    _a[E_ICONS.FULLSCREEN] = FullscreenIcon,
    _a[E_ICONS.FULLSCREEN_EXIT] = FullscreenExitIcon,
    _a[E_ICONS.GROUP] = GroupIcon,
    _a[E_ICONS.HEART_PULSE] = HeartPulseIcon,
    _a[E_ICONS.HISTORY] = HistoryIcon,
    _a[E_ICONS.IDENTITY_FRAUD] = IdentityFraudIcon,
    _a[E_ICONS.IDENTITY_INCOMPLETED] = IdentityIncompleteIcon,
    _a[E_ICONS.IDENTITY_NEVER_COMPLETED] = IdentityNeverCompletedIcon,
    _a[E_ICONS.IDENTITY_TO_STUDY] = IdentityToStudyIcon,
    _a[E_ICONS.IDENTITY_VALID] = IdentityValidIcon,
    _a[E_ICONS.INFO] = InfoIcon,
    _a[E_ICONS.INFORMATION] = InformationIcon,
    _a[E_ICONS.LOCK] = LockIcon,
    _a[E_ICONS.LOGOUT] = LogoutIcon,
    _a[E_ICONS.MESSAGE] = MessageIcon,
    _a[E_ICONS.MORE] = MoreIcon,
    _a[E_ICONS.NOTIFICATION_OFF] = NotificationOffIcon,
    _a[E_ICONS.NOTIFICATION_ON] = NotificationOnIcon,
    _a[E_ICONS.PDF] = PDFIcon,
    _a[E_ICONS.PICTURE] = PictureIcon,
    _a[E_ICONS.PLAY] = PlayIcon,
    _a[E_ICONS.PAUSE] = PauseIcon,
    _a[E_ICONS.QUESTION] = QuestionIcon,
    _a[E_ICONS.QUESTION_CIRCLE] = QuestionCircleIcon,
    _a[E_ICONS.QUICKSIGN] = QuicksignIcon,
    _a[E_ICONS.REFRESH] = RefreshIcon,
    _a[E_ICONS.ROLLBACK] = RollbackIcon,
    _a[E_ICONS.ROTATE_LEFT] = RotateLeftIcon,
    _a[E_ICONS.ROTATE_RIGHT] = RotateRightIcon,
    _a[E_ICONS.SEARCH] = SearchIcon,
    _a[E_ICONS.SEND] = SendIcon,
    _a[E_ICONS.SETTINGS] = SettingsIcon,
    _a[E_ICONS.STATEMENT] = StatementIcon,
    _a[E_ICONS.SUB] = SubIcon,
    _a[E_ICONS.TRASH] = TrashIcon,
    _a[E_ICONS.USER] = UserIcon,
    _a[E_ICONS.WALLET] = WalletIcon,
    _a[E_ICONS.WARNING] = WarningIcon,
    _a[E_ICONS.ZOOM_IN] = ZoomIn,
    _a[E_ICONS.ZOOM_OUT] = ZoomOut,
    _a);
